export class RequestModel {
    class: string;
    fetchCriteria: any;
    brokerAccountClientIds: any;
    serviceOfferCodes: any;
    excludeProductsWithZeroAvailableLicenses: boolean;
    billingClientId: string;
    serviceStatus: string;
    catalogStatus: string;
    excludeAddons: boolean;
    withAvailableLicenses: boolean;
    withAssignedLicenses: boolean;
    constructor() {
        this.fetchCriteria = {};
        this.brokerAccountClientIds = undefined;
        this.serviceOfferCodes = undefined;
        this.class = undefined;
        this.excludeProductsWithZeroAvailableLicenses = undefined;
        this.billingClientId = undefined;
        this.serviceStatus = undefined;
        this.catalogStatus = undefined;
        this.excludeAddons = undefined;
        this.withAvailableLicenses = undefined;
        this.withAssignedLicenses = undefined;
    }
}
